import { render, staticRenderFns } from "./BaseInputField.vue?vue&type=template&id=521ca6e7&scoped=true"
import script from "./BaseInputField.vue?vue&type=script&lang=js"
export * from "./BaseInputField.vue?vue&type=script&lang=js"
import style0 from "./BaseInputField.vue?vue&type=style&index=0&id=521ca6e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ca6e7",
  null
  
)

export default component.exports